import React, { useEffect } from "react";
import { useAuth } from "react-oidc-context";

function LogoutPage() {
  const auth = useAuth();

  useEffect(() => {
    if (auth.isAuthenticated) {
      auth.removeUser();
    }
  }, [auth.isAuthenticated, auth]);

  return (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      <h2>You have been signed out</h2>
      <p>Thank you for using TraQR.</p>
      <p>
        Click{"  "}
        <button
          onClick={() => auth.signinRedirect()}
          style={{
            all: "unset",
            color: "blue",
            textDecoration: "underline",
            cursor: "pointer",
          }}
          data-testid="signin-link"
        >
          here
        </button>
        {"  "} to
        <span style={{ fontWeight: "bold" }}> sign in </span>
        again
      </p>
    </div>
  );
}

export default LogoutPage;
